import React from "react";
import { View, TouchableOpacity, Text, StyleSheet, Platform, Linking } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import colors from "../theme/colors";

const CustomBottomTab = ({ state, navigation }) => {
  const handleHomePress = () => {
    navigation.navigate("HomeTab", {
      screen: "HomeMain",
    });
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity style={styles.tabButton} onPress={handleHomePress}>
        <Ionicons
          name={state.index === 0 ? "home" : "home-outline"}
          size={24}
          color={state.index === 0 ? colors.primary : colors.gray}
        />
        <Text style={[styles.label, state.index === 0 && styles.activeLabel]}>Home</Text>
      </TouchableOpacity>

      <View style={styles.centerTabContainer}>
        <TouchableOpacity
          style={styles.plusButton}
          onPress={() => Linking.openURL("https://maps.kuwaitiwords.com/")}>
          <View style={styles.plusButtonInner}>
            <Ionicons name="location" size={32} color={colors.white} />
          </View>
        </TouchableOpacity>
        <Text style={styles.exploreLabel}>Explore</Text>
      </View>

      <TouchableOpacity style={styles.tabButton} onPress={() => navigation.navigate("Words")}>
        <Ionicons
          name={state.index === 1 ? "book" : "book-outline"}
          size={24}
          color={state.index === 1 ? colors.primary : colors.gray}
        />
        <Text style={[styles.label, state.index === 1 && styles.activeLabel]}>Words</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    height: 80,
    backgroundColor: colors.secondary,
    alignItems: "center",
    justifyContent: "space-around",
    paddingBottom: Platform.OS === "ios" ? 20 : 10,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: -2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 5,
  },
  tabButton: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  centerTabContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-end",
    paddingBottom: 0,
  },
  plusButton: {
    top: -20,
    padding: 8,
    backgroundColor: "transparent",
    marginBottom: -24,
  },
  plusButtonInner: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: colors.primary,
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  label: {
    fontSize: 12,
    marginTop: 4,
    color: colors.gray,
  },
  activeLabel: {
    color: colors.primary,
  },
  exploreLabel: {
    fontSize: 12,
    marginTop: 4,
    color: colors.gray,
    marginBottom: 0,
  },
});

export default CustomBottomTab;
